import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { ActivitiesPage } from './ActivitiesPage'
import { ActivityPage } from './ActivityPage'
import { SleepPage } from './SleepPage'

// Сон и активности — отдельные пункты меню (не вкладки /metrics: см. interfaces.md, тикет 03).
export const routes: RouteObject[] = [
  { path: '/sleep', element: <SleepPage /> },
  { path: '/activities', element: <ActivitiesPage /> },
  { path: '/activities/:id', element: <ActivityPage /> },
]

export const nav: NavItem[] = [
  { path: '/sleep', label: 'Сон', icon: 'moon', mobile: 'more', order: 52 },
  { path: '/activities', label: 'Активности', icon: 'activity', mobile: 'more', order: 54 },
]
